import styled from 'styled-components'

const Container = styled.div`
  .MuiTab-textColorInherit.Mui-selected {
    opacity: 1;
    color: #0a1f30;
    font-family: "latobold" !important;
  }
  .MuiBox-root {
    padding: 0;
  }
  .MuiTab-root {
    opacity: 1;
    text-transform: capitalize;
    font-family: "latomedium";
    padding: 15px !important;
  }
  .MuiAppBar-colorPrimary {
    color: #7a7a7a;
    background-color: transparent;
    box-shadow: none;
    text-transform: capitalize;
  }
  .MuiTabs-indicator {
    border: solid 2px #2fb5f1;
  }
  .MuiFormGroup-row {
    flex-direction: row;
    height: 30px;
    margin-bottom: 13px;
  }
`;
const PanelWrapper = styled.div`
    background-color: #f9f9f9;
    padding: 15px;
    /* line-height:40px; */
    display: flex;
    /* align-items: flex-end; */
    flex-wrap: wrap;

         p {
            margin:0;
            span {
                color: orange;
            }
        }
        > div {
            margin-right:10px;
            :last-child {
                margin-right: 0;
            }
        }        
`
const InnerDiv = styled.div`
    /* display:flex;
    flex-direction: column;
    flex:1;  */
`
const DateRangeInnerDiv= styled.div`
  display: flex;
  gap: 10px;
  align-items: flex-end;

`

const ContentHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: solid 1px #97979729;
        padding: 0 20px;
        height: 80px;
    h3 {
        text-transform: uppercase;
        font-family: "latobold";
        font-size: 16px;
    }

`
const Wrapper = styled.div`
    box-shadow: 0 0 12px 0 rgb(0 0 0 / 8%);
    background-color: #ffffff;
    min-height: 249px;
    position: relative;
    -webkit-flex: 1;
    -ms-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
`
const SelectWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    select, input {
        background-color: #ffffff;
        padding: 5px;
        border: solid 1px #97979729 !important;
        border-radius: 3px;
        margin: 2px 0;
        font-size: 14px;
        height: 32px;
    };
    label {
        background-color: #ffffff;
        padding: 5px;
        margin: 2px 0;
        font-size: 14px;
    }
`
const Header = styled.div`
    height: 150px;
    display: flex;
    flex-direction : column;
    padding: 0 20px;
    border-bottom: solid 1px #97979729;

    > div >h3 {
        margin-Top : 20px;
        font-size: 17px;
        color: #000000;
        text-transform: uppercase;
          font-family: "latobold";
    }
    @media (max-width: 465px){
      height: auto;
    }
 `

const SearchSection = styled.div`
.type-ahead-search-input {
  width: min(341px, 24vw);
  @media (max-width:650px) {
    width: 100%;
  }
}
`;

const TableWrapper = styled.div`
    border-radius: 15px;
    border: solid 1px #87cdf1;
    margin-bottom: 20px;
    box-shadow: 0 9px 8px 0 rgb(0 0 0 / 16%);
    .table thead th {
        vertical-align: top;
    }
    .MuiPagination-ul {
        padding: 15px;
    }
    .MuiTab-textColorInherit.Mui-selected {
    opacity: 1;
    color: #0a1f30;
    font-family: "latobold" !important;
  }
  .MuiBox-root {
    padding: 0;
  }
  .MuiTab-root {
    opacity: 1;
    text-transform: capitalize;
    font-family: "latomedium";
    padding: 15px !important;
  }
  .MuiAppBar-colorPrimary {
    color: #7a7a7a;
    background-color: transparent;
    box-shadow: none;
    text-transform: capitalize;
  }
  .MuiTabs-indicator {
    border: solid 2px #2fb5f1;
    /* color: #0a1f30; */
  }
`
const DateWrapper = styled.div`
  display: block;
  .file-input-wrapper .MuiFormControl-root{
    background: #e8e2e2;
    border: solid 1px #e8e2e2;
    border-radius: 2px;
    height: 46px;
  }
  input {
    padding: 5px;
    border: solid 1px transparent !important;
    margin: 2px 0;
    font-size: 16px;
    padding: 5px 13px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    min-width: 130px;
    max-width: 150px;
    max-height: 42px;
    ::-webkit-input-placeholder {
      /* Edge */
      color: #656565;
    }

    :-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #656565;
    }

    ::placeholder {
      color: #656565;
    }
  }
  label {
    padding: 5px;
    margin: 2px 0 0;
    font-size: 16px;
    width: 100%;
  }
`;

export const MultiSelectFieldWrapper = styled.div`
  max-width: 270px;
  margin-top: 6px;
  label{
    margin-bottom: 9px;
  }
  .select__value-container{
    max-height: 75px;
    overflow: auto;
    min-height: 41px;
  }
`
export { Wrapper, Container, DateRangeInnerDiv, ContentHeader, PanelWrapper, SelectWrapper, InnerDiv, Header, SearchSection, TableWrapper, DateWrapper };